import { render, staticRenderFns } from "./LevelSuccessView.vue?vue&type=template&id=5a51561c&scoped=true&"
import script from "./LevelSuccessView.vue?vue&type=script&lang=js&"
export * from "./LevelSuccessView.vue?vue&type=script&lang=js&"
import style0 from "./LevelSuccessView.vue?vue&type=style&index=0&id=5a51561c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a51561c",
  null
  
)

/* custom blocks */
import block0 from "./LevelSuccessView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports